import React from 'react';
import stats from '../data/stats.json';
import { useCountUp } from '../hooks/useCountUp';

const labelStyle: React.CSSProperties = {
  margin: '8px 0 0',
  color: 'var(--color-muted)',
  fontSize: 14,
  letterSpacing: '0.1em',
  textTransform: 'uppercase'
};

const numberStyle: React.CSSProperties = {
  fontFamily: 'var(--font-display)',
  fontSize: 'clamp(2rem, 5vw, 3.5rem)',
  color: 'var(--color-accent)',
  lineHeight: 1,
  fontVariantNumeric: 'tabular-nums',
  fontFeatureSettings: '"tnum"'
};

export function StatTriad() {
  const { value, ref } = useCountUp(stats.pairs);
  return (
    <dl
      className="stat-triad"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 'var(--space-xl)',
        textAlign: 'center',
        margin: 0,
        maxWidth: 720,
        width: '100%'
      }}
    >
      <div>
        <dt style={labelStyle}>Bilateral Pairs</dt>
        <dd ref={ref as React.Ref<HTMLElement>} style={{ ...numberStyle, margin: 0 }}>
          {value.toLocaleString()}
        </dd>
      </div>
      <div>
        <dt style={labelStyle}>UN Member States</dt>
        <dd style={{ ...numberStyle, margin: 0 }}>{stats.countries}</dd>
      </div>
      <div>
        <dt style={labelStyle}>Contributors &amp; Experts</dt>
        <dd style={{ ...numberStyle, margin: 0 }}>{stats.contributors}</dd>
      </div>
    </dl>
  );
}
